var bindFacetsToImageUrl = function(facetsToCache) {
    //append facetCache to product urls
    if (facetsToCache != null && facetsToCache != "") {
        $('.product-link').each(function() {
            if ($(this).attr("href").indexOf("facetCache") == -1) $(this).attr('href', $(this).attr('href') + '&facetCache=' + encodeURIComponent(facetsToCache));
        });
        if ($('.result-list').length > 0) {
            $('.rec-list a').not('.quickview-btn').each(function() {
                $(this).attr('href', $(this).attr('href').split('&facetCache')[0] + '&facetCache=' + encodeURIComponent(facetsToCache));

            });
        }
    }
};

export{bindFacetsToImageUrl}
